module.exports = global["$"] = require("-!/mnt/jenkins/jobs/Prod - Build and Deploy Client Area UI/workspace/client/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 391
// module chunks = 0